<template>
  <div class="el-tabs__inner">
    <el-row :gutter="10" class="row-bg">
      <draggable
        :list="fields"
        :clone="clone"
        class="dragArea"
        :group="{ name: 'formbuilder', pull: 'clone', put: false }"
        :sort="false"
      >
        <el-col
          :span="24"
          :class="{ 'is-disabled': checkStopDragCondition(field) }"
          v-for="(field, index) in fields"
          :key="index"
        >
        <!-- <el-tooltip
            placement="top"
            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
            :content="field.description"> -->
            
            <!-- <el-button class="button__sidebar"> -->
              <div class="d-flex flex-row align-content-center button__sidebar ml-2" style="color:#000;">
                <i :class="field.icon" class="pl-2"></i> 
                <p class="pl-4 mt-2">{{ field.text }}</p>
              </div>
               <hr style="margin-top:-2px;border-color:#000;"/>
          
            <!-- </el-button> -->
        <!-- </el-tooltip> -->
        </el-col>
      </draggable>
    </el-row>
  </div>
</template>

<script>
import { FormBuilder } from "./formbuilder";
import draggable from "vuedraggable";

export default {
  name: "Elements",
  // store: ["forms"],
  components: {
    draggable,
  },
  data() {
    return {
      fields: FormBuilder.$data.fields,
      dropElementOptions: FormBuilder.$data.dropElementOptions,
    };
  },
  computed: {
    forms() {
      return this.$store.state.formBuilder.forms;
    },
    theemMode() {
      return this.$store.state.theme;
    },
  },
  methods: {
    clone(field) {
      return _.cloneDeep(field);
    },
    checkStopDragCondition(field) {
      var form = this.forms,
        formArray = [];

      for (var key in form) {
        formArray.push(form[key]["fieldType"]);
      }
      // Check if the fieldname exist in formArray
      // And when the field.isUnique too
      return _.includes(formArray, field.name) && field.isUnique;
    },
  },
};
</script>

<style lang="scss" scoped>
.button__sidebar {
  width: 100%;
  margin-bottom: 2px;
  cursor: move;
  .is-disabled & {
    opacity: 0.4;
  }
}
// .button__sidebar:hover{
//   background-color: #ecf5ff;
//   color:#000;
// }


// Display this ghost in <main> only
.sortable__ghost {
  position: relative;
  width: 33.33%;
  border-bottom: 2px solid #3a8ee6;
  margin-top: 2px;
  margin-bottom: 2px;

  [type="button"] {
    display: none;
  }

  &:before {
    content: "Drag it here";
    background-color: #ecf5ff;
    color: #3a8ee6;
    position: absolute;
    left: 50%;
    font-size: 10px;
    border-radius: 10px;
    line-height: 15px;
    padding: 0 10px;
    top: -6px;
    transform: translateX(-50%);
  }
}
</style>
